module.exports = __webpack_public_path__ + "static/media/sadface.3464c44057cdca358cdd05b825b6426b.svg";